export default __webpack_public_path__ + "static/media/slide-six.50aed45c.png";